import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, AbstractControl, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DtoClientAdmin, ClientAccountDetails, DtoClientAccount, Pagination, Document, UserRoles } from '../../models/mat-account.model';
import { Users } from '../../models/user-center.model';
import { MatAccountService } from './mat-account.service';
import { Tabs } from '../package-center/package-center.component';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { HelperMethods } from '../common/helper-methods.service';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { DocumentType, MatDialogCloseEvent, Mode, PageKey } from '../../const';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';
import { SharedService } from '../../shared/services/shared.service';
import { Subscription } from 'rxjs';
import { DtoSchool, DtoSchoolAdmin, DtoSchoolUser } from '../../models/school.model';
import { SchoolService } from '../school/school.service';
import { Role, RolePayload } from '../../models/role.model';
import { RoleMaster } from '../user-center/user-role/user-role.component';
import { EditAccountDetailsComponent } from '../user-center/edit-account-details/edit-account-details.component';
import * as XLSX from 'xlsx';
import { SendBulkEmailComponent } from './send-bulk-email/send-bulk-email.component';
import { PackageService } from '../package-center/package/package.service';
import { SearchService } from '../common/search.service';

interface UploadFileList {
  id: string | null;
  files: File[];
}

@Component({
  selector: 'app-mat-account',
  templateUrl: './mat-account.component.html'
})
export class MatAccountComponent implements OnInit, OnDestroy {
  @ViewChild('uploadFileInput') uploadFileInput: ElementRef | undefined;
  @Input() buttonTitle: string = 'Upload from Device';
  @Output() fileChange = new EventEmitter<FileList>();
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChildren('adminFileInput') fileInputs!: QueryList<ElementRef<HTMLInputElement>>;

  private schoolFormSubscription: Subscription | undefined;
  subscription: Subscription = new Subscription();
  currentStep: number = 0; // Property to define the current step in mat account creation
  steps = Steps; // Enum to define the total number of steps
  openCreateMatForm: boolean = false; // Property to define whether to show/hide the back/cancel/next button
  packageToAssign: number = 0; // Property to define whether the package is assigned
  showForm: boolean = false; //Property to define whether 'Create Package' is triggered
  openedPackage: boolean = false; //Property to define whether 'Create Package/Edit Package' is triggered
  isOffcanvasVisible: boolean = false;
  matAccountToEdit: DtoClientAccount = {} as DtoClientAccount;
  matAccountForm = new FormGroup({
    clientAccountName: new FormControl('', [
      Validators.required,
      Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
    ]),
    clientReference: new FormControl('', [
      Validators.required,
      Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
    ]),
    numberOfClientAdmin: new FormControl(1, [Validators.required]),
    assignedAccountAdmin: new FormControl({} as Users, [
      Validators.required,
      Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
    ]),
    notes: new FormControl('', [
      Validators.required,
      Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
    ]),
    clientAdmins: new FormArray([]),
    sectorId: new FormControl(0, [
      Validators.required
    ]),
  });
  accountAdminList: Users[] = [];
  activeTab: string = Tabs.Package;
  matAccountList: ClientAccountDetails[] = [];
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  role = RoleMaster;
  userRole: string[] = [];
  searchTerm: string = "";
  pageKey = PageKey.UserCenter;
  roleName: string[] = [];
  isEdit: boolean = false;
  totalRecords: number = 0;
  pagination: Pagination = {
    searchTerm: "",
    pageOffset: 0,
    pageSize: 10,
    sortColumn: "",
    sortDirection: "",
    userRole: [] as string[]
  }
  selectedFile: File | null = null;
  matAccountUploadFileList: File[] = [];
  matAdminUploadFileLists: { [index: number]: UploadFileList } = {};
  schoolAccountUploadedFileList: { [index: number]: UploadFileList } = {};
  schoolAdminUploadedFileLists: { [index: number]: UploadFileList } = {};
  schoolUserUploadedFileLists: { [index: string]: UploadFileList } = {};
  selectedMatFileCount: number = 0;
  selectedMatAdminFileCount: number[] = [];
  userEmail: string = "";
  schoolDetailsForm = this.fb.group({
    schools: this.fb.array([])
  });
  roleForm = new FormGroup({
    roleDetails: new FormArray([]),
  });
  completedProcess: boolean = false;
  createdSchoolDetails: DtoSchool[] = [];
  createdMatAccount: DtoClientAccount = {} as DtoClientAccount;
  createdMatAccountId: number = 0;
  roles: Role[] = [];
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  currentFileUploadAdminIndex: number = 0;
  maxStep: number = 0;
  partialSave: boolean = false;
  excelData: any[] = [];
  sectorId: number = 0;

  constructor(
    private matAccountService: MatAccountService,
    private toasterService: ToastrService,
    public helperMethods: HelperMethods,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<MatAccountComponent>,
    private sharedService: SharedService,
    private fb: FormBuilder, private schoolService: SchoolService,
    private packageService: PackageService, private readonly searchService: SearchService
  ) { }
  ngOnInit(): void {
    this.sectorId = Number(sessionStorage.getItem('sector'));
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });
    this.addMatAdminDetail();
    this.getAccountAdminDetails();
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
    this.getMatAccount(this.pagination);
    this.subscription.add(this.sharedService.doFileUpload.subscribe((data) => {
      if (data) {
        this.uploadFromLocal(data, true);
      }
      else {
        this.MatAdminuploadFromLocal(data, this.currentFileUploadAdminIndex, true);
      }

    }));

    this.subscription.add(this.sharedService.showFilePreview.subscribe((data) => {
      this.previewFile(data);
    }));

    this.userEmail = sessionStorage.getItem('user_email')!;
    this.schoolFormSubscription = this.sharedService.schoolFormValidity.subscribe(schoolForm => {
      this.schoolDetailsForm = schoolForm;
    });
    this.sharedService.roleFormValidity.subscribe(roleForm => {
      this.roleForm = roleForm;
    });
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  clearMatAccountForm() {
    this.matAccountForm.reset();
    this.matAdminUploadFileLists = [];
    this.matAccountUploadFileList = [];
    this.selectedMatFileCount = 0;
    this.selectedMatAdminFileCount = [];
    let arrayLength = this.clientAdminsArray.length;
    for (let i = 0; i < arrayLength; i++) {
      this.clientAdminsArray.removeAt(i);
      if (this.clientAdminsArray.length == 0) {
        this.addMatAdminDetail();
      }
    }
  }

  getMatAccount(payload: Pagination) {
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    payload.searchTerm = this.searchTerm.trim();
    payload.userRole = this.userRole;
    this.matAccountService.getMatAccount(this.sectorId, payload).subscribe((response: ClientAccountDetails[] | any) => {
      this.matAccountList = response;
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.matAccountUploadFileList = response.document;
      this.resetMatAccountCreationProcess();
    }, (error: HttpErrorResponse) => {
      if (error.error) {
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  previewFile(file: Document) {
    let link = document.createElement("a");
    if (link.download !== undefined) {
      let blob = new Blob([file.fileData!], { type: file.filePath });
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", file.fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  }
  getAccountAdminDetails() {
    let payload: UserRoles = {} as UserRoles;
    payload.userRole = this.userRole;
    this.matAccountService.getAccountAdminDetails(this.userRole).subscribe((response: Users[] | any) => {
      this.accountAdminList = response;
    }, (err: HttpErrorResponse) => {
      if (err.error) {
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  receivedPackage(packageId: number) {
    this.packageToAssign = packageId;
  }

  hideNavigationButtons(value: boolean) {
    //Value == false : Edit Package is triggered
    if (value) {
      this.showForm = false;
    }
    this.currentStep = value
      ? this.steps.AssignPackage
      : this.steps.EditPackage;
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    this.openCreateMatForm = value;
    this.openedPackage = !this.openCreateMatForm;
  }

  goToSelectedStep(stepToChange: number) {
    if (stepToChange <= this.maxStep) {
      this.currentStep = stepToChange;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
      this.isEdit = this.setValueForIsEdit(this.currentStep, true);
    }
  }

  setValueForIsEdit(currentStep: number, checkForFormValidity: boolean = false): boolean {
    if (this.maxStep <= this.steps.AssignPackage) {
      return false;
    }
    else if (currentStep == this.steps.MatAdminDetails || currentStep == this.steps.AssignPackage) {
      return this.createdMatAccountId > 0;
    }
    else if (currentStep == this.steps.AddSchool || currentStep == this.steps.CreateRole) {
      if (currentStep == this.steps.AddSchool && checkForFormValidity) {
        return this.isFormValidExceptSchoolUsers();
      }
      return this.createdSchoolDetails && this.createdSchoolDetails.length > 0 && this.createdSchoolDetails[0].schoolId! > 0;
    }
    else {
      return false;
    }
  }

  disableNext(currentStep: number) {
    switch (currentStep) {
      case this.steps.MatAdminDetails:
        if (this.matAccountForm.invalid || this.matAccountForm.untouched) {
          this.matAccountForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else {
          return true;
        }
      case this.steps.AssignPackage:
        if (this.packageToAssign == 0) {
          this.toasterService.warning("Please select a package to proceed");
          return false;
        }
        else {
          return true;
        }
      case this.steps.CreateRole:
        if (this.roleForm.invalid || this.roleForm.untouched) {
          this.roleForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else {
          return true;
        }
      case this.steps.AddSchool:
        if (!this.isFormValidExceptSchoolUsers()) {
          this.schoolDetailsForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else {
          return true;
        }
      case this.steps.CreateUser:
        if (this.schoolDetailsForm.invalid || this.schoolDetailsForm.untouched) {
          this.schoolDetailsForm.markAllAsTouched();
          this.toasterService.warning("Please fill the required fields to proceed");
          return false;
        }
        else {
          return true;
        }
      default:
        return true;
    }
  }

  async triggerAction() {
    if (!this.disableNext(this.currentStep)) {
      return;
    }
    let matAccountDetails = JSON.parse(
      JSON.stringify(this.matAccountForm.getRawValue())
    );

    matAccountDetails.ClientAccountId = 0;

    this.isEdit = this.setValueForIsEdit(this.currentStep);

    if (this.currentStep == this.steps.MatAdminDetails || this.currentStep == this.steps.AddSchool || this.currentStep == this.steps.CreateRole) {
      let validateOn: string = "";
      if (this.currentStep == this.steps.MatAdminDetails) {
        validateOn = "matAdmin";
      }
      else if (this.currentStep == this.steps.AddSchool) {
        validateOn = "school";
        matAccountDetails.schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));
      }
      else if (this.currentStep == this.steps.CreateRole) {
        validateOn = "role";
        matAccountDetails.schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));
        for (const element of matAccountDetails.schools) {
          let school = element;
          school.role = this.roleForm.value.roleDetails;
        }
      }
      const isValid = await this.validateJson(matAccountDetails, validateOn)
      if (!isValid) {
        return;
      }
    }

    if (this.currentStep == this.steps.MatAdminDetails) {
      if (this.clientAdminsArray.controls.length > this.matAccountForm.controls['numberOfClientAdmin'].value!) {
        this.toasterService.error("Maximum number of client admins that can be created for this account should be " + this.matAccountForm.controls['numberOfClientAdmin'].value);
        return;
      }
      this.currentStep = this.steps.AssignPackage;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    }
    else if (this.packageToAssign > 0 && this.currentStep != this.steps.AddSchool && this.currentStep != this.steps.CreateUser && this.currentStep != this.steps.CreateRole) {
      this.createMatAccount();
    }
    else if (this.currentStep == this.steps.AddSchool) {
      if (this.partialSave) {
        this.createSchools();
        return;
      }
      this.currentStep = this.steps.CreateRole;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    }
    else if (this.currentStep == this.steps.CreateRole) {
      this.createSchools();
    }
    else if (this.currentStep == this.steps.CreateUser) {
      this.createSchoolUsers();
    }
    else {
      this.roleForm.markAllAsTouched();
      this.schoolDetailsForm.markAllAsTouched();
      this.matAccountForm.markAllAsTouched();
      this.toasterService.warning("Please fill the required fields to proceed");
    }
  }

  isFormValidExceptSchoolUsers(): boolean {
    const schools = this.schoolDetailsForm.get('schools') as FormArray;

    if (!schools) {
      return true;
    }
    // Temporarily disable all schoolUsers controls
    schools.controls.forEach(school => {
      const schoolUsers = school.get('schoolUsers') as FormArray;
      schoolUsers.disable({ emitEvent: false });
    });

    // Check form validity
    const isValid = this.schoolDetailsForm.valid;

    // Re-enable all schoolUsers controls
    schools.controls.forEach(school => {
      const schoolUsers = school.get('schoolUsers') as FormArray;
      schoolUsers.enable({ emitEvent: false });
    });

    return isValid;
  }

  handleBack() {
    if (this.currentStep == this.steps.AssignPackage) {
      this.currentStep = this.steps.MatAdminDetails;
      this.openedPackage = false;
    }
    else if (this.currentStep == this.steps.CreateRole) {
      this.currentStep = this.steps.AddSchool;
    }
    else if (this.currentStep == this.steps.AddSchool) {
      this.patchMatAdminDetail(this.createdMatAccount);
      this.currentStep = this.steps.AssignPackage;
    }
    else if (this.currentStep == this.steps.CreateUser) {
      this.currentStep = this.steps.CreateRole;
    }
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    this.isEdit = this.setValueForIsEdit(this.currentStep, true);
  }

  addMatAdminDetail(clientAdmins: DtoClientAdmin[] = []) {
    if (clientAdmins.length) {
      clientAdmins.forEach((data: DtoClientAdmin) => {
        let newForm = this.getMatAdminDetailForm();
        let examplePhoneNumber = `+${data.countryCode?.toString()!}${data.phoneNumber?.toString()!}`;
        let formattedNumber = this.phoneNumberUtil.format(
          this.phoneNumberUtil.parse(examplePhoneNumber),
          PhoneNumberFormat.INTERNATIONAL
        );
        newForm.patchValue({
          clientAdminId: data.clientAdminId,
          firstName: data.firstName,
          lastName: data.lastName,
          emailId: data.emailId,
          contactNumber: formattedNumber,
          notes: data.notes
        });
        this.clientAdminsArray.insert(0, newForm);
      });
    } else {
      if (this.matAccountForm.controls['numberOfClientAdmin'].value == this.clientAdminsArray.controls.length) {
        this.toasterService.error("Maximum number of client admins for this account has already been created");
        return;
      }
      const form = this.getMatAdminDetailForm();
      this.clientAdminsArray.push(form);
    }
  }

  patchMatAdminDetail(data: DtoClientAccount) {
    let accountAdmin: any = this.accountAdminList.find(x => x.userId == data.assignedAccountAdmin)!;
    this.matAccountForm.patchValue({
      clientAccountName: data.clientAccountName,
      clientReference: data.clientReference,
      numberOfClientAdmin: data.numberOfClientAdmin,
      notes: data.notes,
      assignedAccountAdmin: accountAdmin
    });

    this.matAccountForm.markAllAsTouched();
    this.clientAdminsArray.clear();
    if (data.clientAdmins?.length) {
      this.addMatAdminDetail(data.clientAdmins);
    }
  }

  get clientAdminsArray(): FormArray {
    return this.matAccountForm.get('clientAdmins') as FormArray;
  }

  getFormGroup(control: AbstractControl) {
    return control as FormGroup;
  }

  getMatAdminDetailForm(): FormGroup {
    return new FormGroup({
      clientAdminId: new FormControl(0),
      firstName: new FormControl('', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
      ]),
      emailId: new FormControl('', [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"),
      ]),
      contactNumber: new FormControl('', [
        this.helperMethods.PhoneNumberValidator(),
      ]),
      notes: new FormControl('')
    });
  }
  sendBulkEmail() {
    this.dialog.open(SendBulkEmailComponent, {
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: { isForMatAccounts: true }
    })
  }
  onDeleteMatAdmin(index: number) {
    var clientAdmin = this.clientAdminsArray.at(index).value;
    if (clientAdmin.clientAdminId > 0) {
      this.dialog.open(ConfirmComponent, {
        width: '375px',
        data: {
          status: true,
          message: "Are you sure want to delete the MAT admin?"
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.matAccountService.deleteMatAdmin(clientAdmin.clientAdminId).subscribe((res) => {
            if (res) {
              this.toasterService.success("MAT admin deleted successfully!", "Success");
            }
          }, (error: HttpErrorResponse) => {
            if (error.error) {
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      });
    }
    this.clientAdminsArray.removeAt(index);
  }

  async validateJson(matAccountDetails: any, validateOn: string): Promise<boolean> {
    if (!matAccountDetails.clientAdmins.length) {
      //this.toasterService.warning("Please provide at least one MAT admin details to proceed");
      this.toasterService.warning("No MAT admin details have been provided.");
      //return false;
    }
    if (matAccountDetails.clientAdmins.length > 0) {
      if (this.hasDuplicates(matAccountDetails.clientAdmins.map((x: DtoClientAdmin) => x.emailId))) {
        this.toasterService.warning("Email address of MAT admin(s) must be unique");
        return false;
      }
    }


    if (this.isFormValidExceptSchoolUsers() || this.schoolDetailsForm.controls['schools']?.valid) {
      if (this.hasDuplicates(matAccountDetails.schools?.map((x: any) => x.schoolName))) {
        this.toasterService.warning("School names must be unique");
        return false;
      }

      if (this.roleForm.valid && this.roleForm.value.roleDetails) {
        if (this.hasDuplicates(this.roleForm.value.roleDetails.map((x: any) => x.roleName))) {
          this.toasterService.warning("Audience types must be unique");
          return false;
        }
      }

      let emails = matAccountDetails.schools?.filter((x: DtoSchool) => x.schoolAdmin && 'emailId' in x.schoolAdmin && x.schoolAdmin.emailId?.trim()).map((x: DtoSchool) => x.schoolAdmin?.emailId?.trim());
      if (this.hasDuplicates(emails)) {
        this.toasterService.warning("Email address of school admin(s) must be unique");
        return false;
      }

      let schoolUserNames: string[] = [];
      let schoolUserEmails: string[] = [];
      for (let i = 0; i < matAccountDetails.schools?.length; i++) {
        let school = matAccountDetails.schools[i];
        school.schoolId = school.schoolId ?? 0;
        school.schoolAdmin.schoolAdminId = school.schoolAdmin.schoolAdminId ?? 0;
        school.schoolAdmin.schoolId = school.schoolAdmin.schoolId ?? 0;
        school.assignedAccountAdmin = school.assignedAccountAdmin?.userId;
        for (let j = 0; j < school.schoolUsers.length; j++) {
          let user = school.schoolUsers[j];
          user.schoolUserId = user.schoolUserId ?? 0;
          user.schoolId = school.schoolId ?? 0;
          let fullName = user.firstName?.trim().concat(user.lastName?.trim());
          if (fullName) {
            schoolUserNames.push(fullName);
            schoolUserEmails.push(user.emailId);
          }
        }
      }
      if (this.hasDuplicates(schoolUserNames)) {
        this.toasterService.warning("Name of school user(s) must be unique");
        return false;
      }

      if (this.hasDuplicates(schoolUserEmails)) {
        this.toasterService.warning("Email Address of school user(s) must be unique");
        return false;
      }
    }

    try {
      matAccountDetails.validateOn = validateOn;
      matAccountDetails.assignedAccountAdmin = matAccountDetails.assignedAccountAdmin?.userId;
      matAccountDetails.clientAdmins.forEach((element: DtoClientAdmin) => {
        element.clientAdminId = this.isEdit ? element.clientAdminId : 0;
      })
      matAccountDetails.isUpdate = this.isEdit;
      const response = await this.matAccountService.validateMatAccount(matAccountDetails);
      if (response.isSuccess) {
        return true;
      } else {
        return false;
      }
    } catch (errorResponse: any) {
      this.toasterService.error(errorResponse.error, (errorResponse.status == 422 ? 'Validation Error' : 'Error'));
      return false;
    }
  }

  async createSchools(): Promise<any> {
    let form = this.schoolDetailsForm.controls['schools'].value;
    let schoolId: any = 0;
    form.forEach((school: any, index: number) => {
      const schoolName = school.schoolName;
      const adminEmailId = school.schoolAdmin?.emailId;
      schoolId = this.createdSchoolDetails.find(x => x.schoolName == schoolName)?.schoolId;

      if (school.schoolAccountUploadFileList) {
        if (!this.schoolAccountUploadedFileList[index]) {
          this.schoolAccountUploadedFileList[index] = { id: null, files: [] };
        }
        const files = school.schoolAccountUploadFileList as File[];
        this.schoolAccountUploadedFileList[index].files = files;
        this.schoolAccountUploadedFileList[index].id = schoolName;
      }

      if (school.schoolAdminUploadFileLists) {
        if (!this.schoolAdminUploadedFileLists[index]) {
          this.schoolAdminUploadedFileLists[index] = { id: null, files: [] };
        }
        const files = school.schoolAdminUploadFileLists as File[];
        this.schoolAdminUploadedFileLists[index].files = files;
        this.schoolAdminUploadedFileLists[index].id = adminEmailId;
      }

      school.assignedAccountAdmin = school.assignedAccountAdmin?.userId;
      school.schoolId = schoolId ?? 0;
      school.id = school.id ?? "";
      school.assignedPackageId = this.packageToAssign;
      school.clientAccountId = this.createdMatAccountId;
      school.role = this.roleForm.value.roleDetails;
      let schoolAdmin: DtoSchoolAdmin = school.schoolAdmin;
      if (schoolAdmin.emailId && schoolAdmin.firstName && schoolAdmin.lastName && schoolAdmin.contactNumber && schoolAdmin.title) {
        schoolAdmin.schoolId = schoolId ?? 0;
        schoolAdmin.schoolAdminId = schoolAdmin.schoolAdminId ?? 0;
        schoolAdmin.countryCode = this.phoneNumberUtil.parse(schoolAdmin.contactNumber?.toString()).getCountryCode()!;
        schoolAdmin.phoneNumber = this.phoneNumberUtil.parse(schoolAdmin.contactNumber?.toString()).getNationalNumber()!;
        schoolAdmin.schoolAdminId = this.isEdit ? schoolAdmin.schoolAdminId : 0;
      }
      else {
        school.schoolAdmin = {} as DtoSchoolAdmin;
      }
      school.schoolUsers = [];
    });

    let schools = JSON.parse(JSON.stringify(form));

    if (this.isEdit) {
      this.schoolService.updateSchool(schools).subscribe((response: any) => {
        if (response) {
          if (this.partialSave) {
            this.toasterService.success("School details updated successfully!", "Success");
            this.getMatAccount(this.pagination);
            return;
          }
          this.isEdit = false;
          this.schoolService.getSchools(this.createdMatAccountId).subscribe((data: DtoSchool[] | any) => {
            this.createdSchoolDetails = data;
            this.currentStep = this.steps.CreateUser;
            this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
            let payload = {
              isIndividualEntity: false,
              clientAccountId: [this.createdMatAccountId]
            } as RolePayload;
            this.schoolService.getRoles(payload).subscribe((response: Role[] | any) => {
              //this.schoolService.getRoles(this.createdMatAccountId).subscribe((response: Role[] | any)=>{
              this.roles = response;
            }, (err: HttpErrorResponse) => {
              if (err.error) {
                this.toasterService.error(err.error, "Error");
              }
            })
          }, (error: HttpErrorResponse) => {
            if (error.error) {
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
    else {
      try {
        //Check if subscription is available for each school's school admin
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToAssign);
        if (numberOfSubscriptionAvailable < schools.filter((school: DtoSchool) => school.schoolId == 0 || school.schoolId == undefined || school.schoolId == null).length) {
          this.toasterService.error("Package has exceeded the maximum number of subscriptions");
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }
      this.schoolService.createSchool(schools, this.createdMatAccountId).subscribe((response: any) => {
        if (response.isSuccess) {
          this.createdSchoolDetails = response.data;
          this.createdSchoolDetails.forEach((schoolDetail) => {
            // Find the matching school account files by school name
            const matchingSchoolAccountFiles = Object.values(this.schoolAccountUploadedFileList).find(
              item => item.id === schoolDetail.schoolName
            );

            // Find the matching school admin files by admin email ID
            const matchingSchoolAdminFiles = Object.values(this.schoolAdminUploadedFileLists).find(
              item => item.id === schoolDetail.schoolAdmin?.emailId
            );

            if (matchingSchoolAccountFiles && matchingSchoolAccountFiles.files.length > 0) {
              const formData = new FormData();
              matchingSchoolAccountFiles.files.forEach((file) => {
                formData.append('file', file, file.name);
              });
              this.uploadDocument(formData, DocumentType.School, schoolDetail.entityId!.toString());
            }

            if (matchingSchoolAdminFiles && matchingSchoolAdminFiles.files.length > 0) {
              const formData = new FormData();
              matchingSchoolAdminFiles.files.forEach((file) => {
                formData.append('file', file, file.name);
              });
              this.uploadDocument(formData, DocumentType.EntityAudience, schoolDetail.schoolAdmin?.userId.toString());
            }
          });
          if (this.partialSave) {
            this.toasterService.success("School(s) created successfully!", "Success");
            this.getMatAccount(this.pagination);
            return;
          }
          this.currentStep = this.steps.CreateUser;
          this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
          let payload = {
            isIndividualEntity: false,
            clientAccountId: [this.createdMatAccountId]
          } as RolePayload;
          this.schoolService.getRoles(payload).subscribe((response: Role[] | any) => {
            //this.schoolService.getRoles(this.createdMatAccountId).subscribe((response: Role[] | any)=>{
            this.roles = response;
          }, (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, "Error");
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
  }

  async createMatAccount(): Promise<any> {
    let matAccountDetails = JSON.parse(
      JSON.stringify(this.matAccountForm.getRawValue())
    );

    matAccountDetails.assignedPackageId = this.packageToAssign;

    try {
      //Check if subscription is available for mat admin
      let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToAssign);
      if (numberOfSubscriptionAvailable < matAccountDetails.clientAdmins.filter((admin: DtoClientAdmin) => admin.clientAdminId == 0 || admin.clientAdminId == undefined || admin.clientAdminId == null).length) {
        this.toasterService.error("Package has exceeded the maximum number of subscriptions");
        return;
      }
    }
    catch (errorResponse: any) {
      this.toasterService.error(errorResponse.error, 'Error');
      return;
    }

    matAccountDetails.assignedAccountAdmin = matAccountDetails.assignedAccountAdmin?.userId;
    matAccountDetails.clientAccountId = this.isEdit ? this.createdMatAccount.clientAccountId : 0;
    const MatAccountformData = new FormData();

    this.matAccountUploadFileList.forEach((file: File) => {
      MatAccountformData.append('file', file, file.name);
    });

    matAccountDetails.clientAdmins.forEach((element: DtoClientAdmin, index: number) => {
      let parsedNumber = this.phoneNumberUtil.parse(element.contactNumber?.toString());
      let countryCode = parsedNumber.getCountryCode();
      let nationalNumber = parsedNumber.getNationalNumber();

      element.countryCode = countryCode!;
      element.phoneNumber = nationalNumber!;
      element.clientAdminId = this.isEdit ? element.clientAdminId : 0;
      if (this.matAdminUploadFileLists[index]) {
        this.matAdminUploadFileLists[index].id = element.emailId;
      }
    })

    if (this.isEdit) {
      this.matAccountService.editMatAccount(matAccountDetails).subscribe((response: any) => {
        if (response.isSuccess) {
          let matAccountId = response.message;
          this.isEdit = false;
          this.matAccountService.getAdminDetails(this.createdMatAccountId).subscribe((response: DtoClientAccount | any) => {
            if (response != null) {
              //File Upload for Mat Account
              if (this.matAccountUploadFileList.length) {
                this.uploadDocument(MatAccountformData, DocumentType.ClientAccount, matAccountId);
              }

              if (this.matAdminUploadFileLists) {
                response.clientAdmins.forEach((admin: DtoClientAdmin) => {
                  let matchedAdminUploadFileList = this.findAdminUploadFileListByMail(admin.emailId!);
                  if (matchedAdminUploadFileList) {
                    let formData = new FormData();
                    matchedAdminUploadFileList.files.forEach((file: File) => {
                      formData.append('file', file, file.name);
                    });
                    this.uploadDocument(formData, DocumentType.ClientAdmin, admin.clientAdminId.toString());
                  }
                });
              }
              if (this.partialSave) {
                this.toasterService.success("MAT Account updated successfully!", "Success");
                this.getMatAccount(this.pagination);
                return;
              }
              this.currentStep = this.steps.AddSchool;
              this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
              this.createdMatAccount = response;
              this.patchMatAdminDetail(this.createdMatAccount);
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
    else {
      this.matAccountService.createMatAccount(matAccountDetails).subscribe((response: any) => {
        if (response.isSuccess) {
          this.createdMatAccountId = response.data.clientAccountId;
          this.matAccountService.getAdminDetails(this.createdMatAccountId).subscribe((response: DtoClientAccount | any) => {
            if (response != null) {
              if (this.matAccountUploadFileList.length) {
                this.uploadDocument(MatAccountformData, DocumentType.ClientAccount, this.createdMatAccountId.toString());
              }
              if (this.matAdminUploadFileLists) {
                response.clientAdmins.forEach((admin: DtoClientAdmin) => {
                  let matchedAdminUploadFileList = this.findAdminUploadFileListByMail(admin.emailId!);
                  if (matchedAdminUploadFileList) {
                    let formData = new FormData();
                    matchedAdminUploadFileList.files.forEach((file: File) => {
                      formData.append('file', file, file.name);
                    });
                    this.uploadDocument(formData, DocumentType.ClientAdmin, admin.clientAdminId.toString());
                  }
                });
              }
              if (this.partialSave) {
                this.toasterService.success("MAT Account created successfully!", "Success");
                this.getMatAccount(this.pagination);
                return;
              }
              this.currentStep = this.steps.AddSchool;
              this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
              this.createdMatAccount = response;
              this.patchMatAdminDetail(this.createdMatAccount);
            }
          }, (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, "Error");
            }
          })
        }
      }, (errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this.toasterService.error(errorResponse.error, "Error");
        }
      })
    }
  }

  findAdminUploadFileListByMail(emailId: string): UploadFileList | undefined {
    return Object.values(this.matAdminUploadFileLists).find(adminUploadFileList => adminUploadFileList.id === emailId);
  }

  async createSchoolUsers(): Promise<any> {
    let schools = JSON.parse(JSON.stringify(this.schoolDetailsForm.controls['schools'].value));
    let form = this.schoolDetailsForm.controls['schools'].value;
    form.forEach((school: any, schoolIndex: number) => {
      const schoolUsers = school.schoolUsers;

      // Loop through each school user to assign files and get the relevant email ID
      schoolUsers.forEach((schoolUser: any, schoolUserIndex: number) => {
        const emailId = schoolUser.emailId;
        const key = `${schoolIndex}_${schoolUserIndex}`;

        if (schoolUser.UploadedFileList) {
          if (!this.schoolUserUploadedFileLists[key]) {
            this.schoolUserUploadedFileLists[key] = { id: null, files: [] };
          }

          // Assign files from the form to the schoolUserUploadedFileLists
          const files = schoolUser.UploadedFileList as File[];
          this.schoolUserUploadedFileLists[key].files = files;
          this.schoolUserUploadedFileLists[key].id = emailId;
        }
      });
    });
    let schoolData: DtoSchool[] = [];
    for (var i = 0; i < schools.length; i++) {
      let school: DtoSchool = schools[i];
      let schoolUsersList = school.schoolUsers
      let savedSchoolData = this.createdSchoolDetails.find(x => x.schoolName == school.schoolName && x.id == school.id);
      school = savedSchoolData!;
      school.schoolId = savedSchoolData!.schoolId;

      if (school.numberOfSchoolUser == 1) {
        this.toasterService.error(`Maximum number of school users for ${school.schoolName} has already been created`);
        return;
      }

      if (school.numberOfSchoolUser! - 1 < schoolUsersList.length) {
        this.toasterService.error(`Maximum number of school users for ${school.schoolName} that could be created is ${school.numberOfSchoolUser}`);
        return;
      }

      try {
        //Check if subscription is available for each school's school user
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToAssign);
        if (numberOfSubscriptionAvailable < schoolUsersList.filter(user => user.schoolUserId == 0 || user.schoolUserId == undefined || user.schoolUserId == null).length) {
          this.toasterService.error("Package has exceeded the maximum number of subscriptions");
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }

      for (const element of schoolUsersList) {
        let schoolUser: DtoSchoolUser = element;
        schoolUser.countryCode = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getCountryCode()!;
        schoolUser.phoneNumber = this.phoneNumberUtil.parse(schoolUser.contactNumber?.toString()).getNationalNumber()!;
        schoolUser.schoolUserId = schoolUser.schoolUserId ?? 0;
        schoolUser.schoolId = schoolUser.schoolId ?? 0;
        if (!schoolUser.role.length) {
          this.toasterService.warning("Please select at least one role to create a user");
          return;
        }
        school.schoolUsers.push(schoolUser);
      }
      schoolData.push(school);
    }

    this.schoolService.createSchoolUsers(schoolData).subscribe((response: any) => {
      if (response.isSuccess) {
        schoolData.forEach((school: DtoSchool) => {
          // Get school users for the current school
          this.schoolService.getSchoolUsers(school.schoolUsers[0].emailId!, school.schoolId!).subscribe(
            (schoolUserResponse: DtoSchoolUser[] | any) => {
              const schoolUserList = schoolUserResponse;
              schoolUserList.forEach((schooluser: DtoSchoolUser) => {
                // Find the matching school account files by school name
                const matchingSchoolUserFiles = Object.values(this.schoolUserUploadedFileLists).find(
                  item => item.id === schooluser.emailId
                );

                if (matchingSchoolUserFiles && matchingSchoolUserFiles.files.length > 0) {
                  const formData = new FormData();
                  matchingSchoolUserFiles.files.forEach((file) => {
                    formData.append('file', file, file.name);
                  });
                  this.uploadDocument(formData, DocumentType.EntityAudience, schooluser.userId.toString());
                }
              });
            },
            (err: HttpErrorResponse) => {
              if (err.error) {
                this.toasterService.error(err.error, "Error");
              }
            }
          );
        });
        this.getMatAccount(this.pagination);
        this.toasterService.success('MAT account created successfully!', 'Success');
      }
    }, (errorResponse: HttpErrorResponse) => {
      if (errorResponse.error) {
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }

  hasDuplicates(valuesToCheck: string[]) {
    if (!valuesToCheck) {
      return false;
    }
    let mySet = new Set(valuesToCheck);
    if (mySet.size !== valuesToCheck.length) {
      return true;
    }
    else {
      return false;
    }
  }

  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if (error.error) {
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }
  uploadFromLocal(event: Event, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.matAccountUploadFileList);
      this.dialog.open(ConfirmDialogComponent, {
        width: '675px', data: {
          hideUpload: false,
          isParentUpload: true
        }
      }).afterClosed().subscribe(() => {
        this.selectedMatFileCount = this.matAccountUploadFileList.length;
      });
    }
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  getFilesForAdmin(index: number): File[] {
    const adminUploadFileList = this.matAdminUploadFileLists[index];
    return adminUploadFileList ? adminUploadFileList.files || [] : [];
  }

  MatAdminuploadFromLocal(event: Event, index: number, triggeredManually = false): void {
    if (!triggeredManually) {
      event.preventDefault();
      this.sharedService.setUploadedFile(this.getFilesForAdmin(index));
      this.dialog.open(ConfirmDialogComponent, {
        width: '675px', data: {
          hideUpload: false,
          isParentUpload: false
        }
      }).afterClosed().subscribe(() => {
        this.selectedMatAdminFileCount[index] = this.getFilesForAdmin(index).length;
      });
      this.currentFileUploadAdminIndex = index;
    }

    // Access the correct file input element for the given index
    const fileInput = this.fileInputs.toArray()[index];
    if (fileInput) {
      fileInput.nativeElement.click();
    }
  }

  actionTriggered(data: ClientAccountDetails): void {
    if (data.action === Mode.Edit) {
      this.matAccountForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
      let clientAccount = {
        clientAccountId: data.clientAccountId,
        clientAccountName: data.clientAccountName,
        clientReference: data.clientReference,
        numberOfClientAdmin: data.numberOfAdmins,
        assignedAccountAdmin: data.assignedAccountAdmin,
        notes: data.comment,
        document: data.document
      } as DtoClientAccount;
      this.dialog.open(EditAccountDetailsComponent, {
        width: '800px',
        data: {
          userRole: this.userRole,
          clientAccount: clientAccount
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.getMatAccount(this.pagination);
        }
      });
    }
    else if (data.action == Mode.View) {
      //go to my insights
      sessionStorage.setItem('client_account', data.clientAccountId.toString());
      sessionStorage.setItem('client_reference', data.clientReference!);
      sessionStorage.setItem('package_of_client_account', data.packageId.toString());
      sessionStorage.removeItem('my_ref_school_id');
      sessionStorage.removeItem('school_id');

      this.sharedService.loadReportForSelectedClientAccountCheck(true);
    }
    else if (data.action === Mode.CreateMatAccount) {
      this.openCreateMatForm = true;
      this.currentStep = this.steps.MatAdminDetails;
      this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
      this.matAccountForm.reset();
      this.resetSchoolForm();
      this.resetRoleForm();
      this.matAccountUploadFileList = [];
      this.matAdminUploadFileLists = {};
    }
    else if (data.action === Mode.Delete) {
      this.dialog.open(ConfirmComponent, {
        width: '375px',
        data: {
          status: true,
          message: "Are you sure want to delete the MAT account?"
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.matAccountService.deleteMatAccount(data.clientAccountId).subscribe((res) => {
            if (res) {
              this.toasterService.success("MAT account deleted successfully!", "Success");
              this.getMatAccount(this.pagination);
            }
          }, (error: HttpErrorResponse) => {
            if (error.error) {
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      });
    }
    else if (data.action == Mode.ChangeStatus) {
      this.dialog.open(ConfirmComponent, {
        width: '375px',
        data: {
          status: data.isActive,
          message: "Are you sure want to" + (data.isActive ? " inactivate" : " activate") + " the MAT account?"
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          this.matAccountService.updateMatAccountStatus(data.clientAccountId).subscribe((res) => {
            if (res) {
              this.toasterService.success("MAT account" + (data.isActive ? " inactivated" : " activated") + " successfully", "Success");
              this.getMatAccount(this.pagination);
            }
          }, (error: HttpErrorResponse) => {
            if (error.error) {
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      });
    }
    else { //Mode.Preview
      this.dialog.open(ConfirmDialogComponent, {
        width: '675px',
        data: {
          hideUpload: true,
          files: data.document // Pass files to the dialog
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.doc) {
          data.document = popupEvent.doc;
        }
      });
    }
  }

  onCreateMatAccount() {
    this.openCreateMatForm = true;
    this.currentStep = this.steps.MatAdminDetails;
    this.maxStep = this.currentStep > this.maxStep ? this.currentStep : this.maxStep;
    this.matAccountForm.reset();
    this.matAccountUploadFileList = [];
    this.matAdminUploadFileLists = {};
    this.selectedMatFileCount = 0;
    this.selectedMatAdminFileCount = [];
    this.resetSchoolForm();
    this.resetRoleForm();
    this.matAccountForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
    if (this.userRole.includes(RoleMaster.AccountAdmin) && this.accountAdminList.length) {
      let assignedAccountAdmin: Users = this.accountAdminList[0];
      this.matAccountForm.controls['assignedAccountAdmin'].setValue(assignedAccountAdmin);
      this.matAccountForm.controls['assignedAccountAdmin'].disable();
    }
  }

  resetMatAccountCreationProcess() {
    this.openCreateMatForm = false;
    this.currentStep = 0;
    this.maxStep = this.currentStep;
    this.packageToAssign = 0;
    this.showForm = false;
    this.isEdit = false;
    this.completedProcess = false;
    this.partialSave = false;
    this.createdSchoolDetails = [];
    this.matAccountForm.reset();
    this.resetSchoolForm();
    this.resetRoleForm();
  }

  onMatAdminFileSelected(event: any, index: number) {
    if (!this.matAdminUploadFileLists[index]) {
      this.matAdminUploadFileLists[index] = { id: null, files: [] };
    }

    if (!this.matAdminUploadFileLists[index].files) {
      this.matAdminUploadFileLists[index].files = [];
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if (event.target.files[i].size <= this.maxSize) {
            let _object: File = event.target.files[i];
            this.matAdminUploadFileLists[index].files.push(_object);
          }
          else {
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.matAdminUploadFileLists[index].files);
      this.selectedMatAdminFileCount[index] = this.matAdminUploadFileLists[index].files.length;

      // Clear the file input value
      if (this.fileInputs.toArray()[index]) {
        this.fileInputs.toArray()[index].nativeElement.value = "";
      }
    }
  }

  onFileSelected(event: any) {
    if (!this.matAccountUploadFileList) {
      this.matAccountUploadFileList = [];
    }

    let filesExist = event.target.files.length;
    if (filesExist > 0) {
      for (let i = 0; i < filesExist; i++) {
        if (event.target.files && event.target.files[i]) {
          if (event.target.files[i].size <= this.maxSize) {
            let _object: File = event.target.files[i];

            this.matAccountUploadFileList.push(_object);
          }
          else {
            this.toasterService.warning('File size must be less than 1 MB.');
          }
        }
      }
      this.sharedService.changeUploadingStatus(false);
      this.sharedService.setUploadedFile(this.matAccountUploadFileList);
      this.selectedMatFileCount = this.matAccountUploadFileList.length;
      this.fileInput!.nativeElement.value = null;
    }
  }

  cancel() {
    if (this.dialogRef) {
      this.dialogRef.close({ event: MatDialogCloseEvent.SUCCESS });
    } else {
      console.log('Not opened as a dialog, no need to close');
    }
  }

  checkFormValidityExceptClientAdmins() {
    const { clientAdmins, ...otherControls } = this.matAccountForm.controls;
    let formValid = true;

    // Loop through other controls to check their validity
    Object.keys(otherControls).forEach((key) => {
      const control = otherControls[key as keyof typeof otherControls];
      if (control.invalid) {
        formValid = false;
        control.markAllAsTouched();
      }
    });

    return formValid;
  }

  bulkUpload() {
    if (!this.checkFormValidityExceptClientAdmins()) {
      this.toasterService.warning("Please fill the details of MAT Account before uploading MAT Admin details");
      return;
    }
    if (this.uploadFileInput) {
      this.uploadFileInput.nativeElement.click();
    }
  }

  loadExcelData(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Assuming your data starts from the second row (index 1) 
      const processedData = data.slice(1)
        .filter((row: any[]) => row.some(cell => cell !== undefined && cell !== null && cell !== ''))
        .map((row: any[]) => ({
          firstName: row[1] || '',
          lastName: row[2] || '',
          emailId: row[3] || '',
          countryCode: row[4] || '',
          phoneNumber: row[5] || ''
        }));

      const numberOfClientAdmins = this.matAccountForm.controls['numberOfClientAdmin'].value!;

      const limitedData = processedData.slice(0, numberOfClientAdmins);

      this.clientAdminsArray.clear();
      limitedData.forEach((row, index) => {
        let examplePhoneNumber = `+${row.countryCode?.toString()!}${row.phoneNumber?.toString()!}`;
        let formattedNumber = this.phoneNumberUtil.format(
          this.phoneNumberUtil.parse(examplePhoneNumber),
          PhoneNumberFormat.INTERNATIONAL
        );
        const formGroup = this.fb.group({
          firstName: [row.firstName, Validators.required],
          lastName: [row.lastName, Validators.required],
          emailId: [row.emailId, [Validators.required, Validators.email]],
          contactNumber: [formattedNumber, Validators.required]
        });

        this.clientAdminsArray.push(formGroup);
      });
    };
    reader.readAsBinaryString(target.files[0]);
    event.target.value = null;
  }

  downloadFile(): void {
    const blobName = 'TemplateForBulkUploadMatAdmin.xlsx'; // Specify the file name you want to download
    this.schoolService.downloadFile(blobName).subscribe((response: any) => {

      var url = response.blobUrl.toString();
      for (var i = 0; i < url.length; i++) {
        url = url.replace("~", "");
        url = url.replace("//", "%2F%2F");
        url = url.replace("/", "%2F");
        url = url.replace(":", "%3A");
      }
      console.log(url);
      var ViewDocumentUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
      window.open(ViewDocumentUrl, "_blank");
    }, (err: HttpErrorResponse) => {
      if (err.error) {
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  resetSchoolForm() {
    // Reset the form values
    this.schoolDetailsForm.reset();

    // Clear the FormArray 'schools'
    const schoolsDetailsArray = this.schoolDetailsForm.get('schools') as FormArray;
    while (schoolsDetailsArray && schoolsDetailsArray.length !== 0) {
      schoolsDetailsArray.removeAt(0); // Remove all controls one by one
    }
    this.sharedService.updateSchoolFormValidity(this.schoolDetailsForm);
  }

  resetRoleForm() {
    // Reset the form values
    this.roleForm.reset();

    // Clear the FormArray 'roleDetails'
    const roleDetailsArray = this.roleForm.get('roleDetails') as FormArray;
    while (roleDetailsArray && roleDetailsArray.length !== 0) {
      roleDetailsArray.removeAt(0); // Remove all controls one by one
    }
    this.sharedService.updateRoleFormValidity(this.roleForm);
  }

  ngOnDestroy() {
    if (this.schoolFormSubscription) {
      this.schoolFormSubscription.unsubscribe();
    }
    this.subscription?.unsubscribe();
  }
}

export enum Steps {
  MatAdminDetails = 1,
  AssignPackage = 2,
  CreatePackage = 3,
  EditPackage = 4,
  AddSchool = 5,
  CreateRole = 6,
  CreateUser = 7
}
